import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const AttachmentFiles = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 30C20.238 30 18 27.762 18 25V21C18 20.45 18.45 20 19 20C19.55 20 20 20.45 20 21V25C20 26.65 21.35 28 23 28C24.65 28 26 26.65 26 25V19C26 18.45 25.55 18 25 18C24.45 18 24 18.45 24 19V25C24 25.55 23.55 26 23 26C22.45 26 22 25.55 22 25V19C22 17.35 23.35 16 25 16C26.65 16 28 17.35 28 19V25C28 27.762 25.762 30 23 30Z" />
		<path d="M15 30H11C8.238 30 6 27.762 6 25V7C6 4.237 8.238 2 11 2H21C23.762 2 26 4.237 26 7V13C26 13.55 25.55 14 25 14C24.45 14 24 13.55 24 13V7C24 5.35 22.65 4 21 4H11C9.35 4 8 5.35 8 7V25C8 26.65 9.35 28 11 28H15C15.55 28 16 28.45 16 29C16 29.55 15.55 30 15 30Z" />
		<path d="M13 20H11C10.45 20 10 19.55 10 19C10 18.45 10.45 18 11 18H13C13.55 18 14 18.45 14 19C14 19.55 13.55 20 13 20Z" />
		<path d="M17 16H11C10.45 16 10 15.55 10 15C10 14.45 10.45 14 11 14H17C17.55 14 18 14.45 18 15C18 15.55 17.55 16 17 16Z" />
		<path d="M21 12H11C10.45 12 10 11.55 10 11C10 10.45 10.45 10 11 10H21C21.55 10 22 10.45 22 11C22 11.55 21.55 12 21 12Z" />
	</svg>
);

export default AttachmentFiles;
